import script from "./consumeAnalyse.vue?vue&type=script&setup=true&lang=js"
export * from "./consumeAnalyse.vue?vue&type=script&setup=true&lang=js"

import "./consumeAnalyse.vue?vue&type=style&index=0&id=b5096aea&scoped=true&lang=css"

import exportComponent from "C:\\D\\workspace\\idea\\tkt-web\\camee-sport-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b5096aea"]])

export default __exports__